import { Menu, Transition } from '@headlessui/react';

import React, { Fragment, useCallback, useRef } from 'react';

import articlesMenuIcon from '_images/articles-menu-icon.svg';
import buyMenuIcon from '_images/buy-menu-icon.svg';
import moreMenuIcon from '_images/more-menu-icon.svg';
import sellMenuIcon from '_images/sell-menu-icon.svg';

export const menuItems = [
  {
    name: 'Sell',
    icon: sellMenuIcon,
    children: [
      {
        name: 'Sell your car to us',
        href: '/sell-my-car-online-to-dealer-singapore/',
      },
      { name: 'Consign your car',
        href: '/consign-a-car/' },
      {
        name: 'Scrap / Export your car',
        href: '/scrap-car-singapore/',
      },
      {
        name: 'Get a car valuation',
        href: '/car-valuation-singapore/',
      },
      {
        name: 'Deregister your car',
        href: '/deregister-your-car/',
      },
      {
        name: 'Trade in your car',
        href: '/trade-in-your-car/',
      },
      {
        name: 'List on Carousell',
        href: 'https://www.carousell.sg/sell/',
        external: true,
      },
    ],
  },
  {
    name: 'Buy',
    icon: buyMenuIcon,

    children: [
      {
        name: 'New Car Pricelists',
        href: '/new-cars/price-lists',
      },
      {
        name: 'Car-buying Personal Assistant',
        href: 'https://carousellautos.oneshift.com/car-buying-personal-assistant',
        external: true,
      },
      {
        name: 'Carousell Certified Cars',
        href: '/carousell-certified-cars-singapore/',
      },
      {
        name: 'Carousell Direct Owner Cars',
        href: 'https://www.carousell.sg/categories/cars-32/used-cars-singapore-1173/?addRecent=true&canChangeKeyword=true&includeSuggestions=true&is_direct_owner=true',
        external: true,
      },
    ],
  },
  {
    name: 'Articles',
    icon: articlesMenuIcon,
    href: '/articles',
    children: [
      {
        name: 'Reviews',
        href: '/articles/car-reviews',
      },
      {
        name: 'Guides',
        href: '/articles/guides/',
      },
      {
        name: 'Features',
        href: '/articles/features',
      },
      {
        name: 'News',
        href: '/articles/news',
      },
      {
        name: 'Motorcycles',
        href: '/articles/motorcycles',
      },
    ],
  },
  {
    name: 'More',
    icon: moreMenuIcon,
    children: [
      {
        name: 'Traffic Cameras',
        href: '/traffic-cameras/',
      },
      {
        name: 'COE Results & History',
        href: '/coe-history/',
      },
      {
        name: 'COE Renewal',
        href: '/coe-renewal-loan/',
      },
      {
        name: 'Loans',
        href: '/car-loan/',
      },
      {
        name: 'Insurance',
        href: '/motor-car-insurance-singapore/',
      },
      {
        name: 'Automotive Specialist Awards 2023',
        href: '/coty-2023/automotive-specialist-award/',
      },
      {
        name: 'Car Of The Year 2024',
        href: '/coty-2024/winners/',
      },
    ],
  },
];

function HeaderMenu() {
  const [openIndex, setOpenIndex] = React.useState(false);
  const justEnter = useRef(false);

  const handleMouseEnter = useCallback((index) => {
    setOpenIndex(index);
    justEnter.current = true;
  }, []);

  const handleMouseLeave = useCallback(() => {
    justEnter.current = false;
    setTimeout(() => {
      if (!justEnter.current) {
        setOpenIndex(false);
      }
    }, 300);
  }, []);

  return (
    <div className="h-full flex items-center">
      {menuItems.map((item, index) => (
        <Menu
          key={item.name}
          as="div"
          className="relative inline-block text-left h-full"
        >
          <a className="block h-full text-content-primary" href={item.href}>
            <Menu.Button
              className="text-sm sm:text-base leading-6 mx-1 sm:mx-3 h-full"
              id={`menu-button-${index}`}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              {item.name}
            </Menu.Button>
          </a>

          {item.children ? (
            <Transition
              show={index === openIndex}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                className="absolute -right-16 sm:left-0 top-[46px] z-50 w-fit rounded bg-white shadow-menu p-3"
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <div className="flex flex-col gap-y-1.5">
                  {item.children.map((child) => (
                    <Menu.Item key={child.name}>
                      {() => (
                        <a
                          href={child.href}
                          className="text-content-primary text-sm leading-5.5 whitespace-nowrap"
                          target={child.external ? '_blank' : '_self'}
                          rel={child.external ? 'noreferrer' : ''}
                        >
                          {child.name}
                        </a>
                      )}
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          ) : null}
        </Menu>
      ))}
      <a
        className="bg-caroured50 text-white mx-3 px-3 rounded-full font-medium text-sm leading-5.5 hover:text-white hidden sm:block"
        href="/coty-2024/winners/"
      >
        COTY 2024
      </a>
    </div>
  );
}

export default HeaderMenu;
